<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import bg from "@/assets/media/error/bg1.jpg";

export default {
  name: "Error-1",
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    backgroundImage() {
      return bg;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Campaigns" }]);
  }
};
</script>

<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
      :style="{
        backgroundImage: `url(${backgroundImage})`
      }"
    >
      <!-- begin:: Content -->
      <h1
        class="font-size-sm-100 font-weight-boldest text-dark-75 mt-15 mb-20"
        style="font-size: 30px;"
      >
        Upgrade Your Account
      </h1>
      <p class="font-size-h3 font-weight-light">
        You must update your account to send a campaign.
      </p>
      <p class="font-size-h3 font-weight-light">
        Please contact us at
        <a href="mailto:info@joinaben.com">info@joinaben.com</a>
      </p>
      <!-- end:: Content -->
    </div>
  </div>
</template>
